import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { addReport } from '../services/adminApi';

const AdminBitcoinsScreen = () => {
  const [formData, setFormData] = useState({
    year: '2025',
    month: 'January',
    totalDeposits: '',
    btcPurchased: '',
    fees: '',
    price: '',
    walletAddress: '',
    availableBtc: '',
    usdtBtcRate: '',
    currentValue: '',
    lossGain: '',
    ngnRate: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear  + i);
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // Validate required fields
      if (!formData.totalDeposits || !formData.btcPurchased || !formData.price) {
        toast.error('Please fill in all required fields');
        return;
      }

      // Call the real API
      const response = await addReport(formData);
      
      if (response.success) {
        toast.success('Report submitted successfully!');
        setFormData({
          year: '2025',
          month: 'January',
          totalDeposits: '',
          btcPurchased: '',
          fees: '',
          price: '',
          walletAddress: '',
          availableBtc: '',
          usdtBtcRate: '',
          currentValue: '',
          lossGain: '',
          ngnRate: ''
        });
      } else {
        toast.error(response.message || 'Failed to submit report');
      }
    } catch (error) {
      console.error('Error submitting report:', error);
      toast.error(error.message || 'An error occurred while submitting the data');
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('is_admin');
    navigate('/admin');
  };

  return (
    <div className="container">
      <div className="admin-header-fullwidth">
        <div className="admin-header-content">
          <div className="admin-header-left">
            <img src="/logo.svg" alt="Project 31 Logo" className="admin-logo" />
           
          </div>
          
          <div className="admin-nav">
            <a href="/admin/dashboard">Dashboard</a>
            <a href="/admin/transactions">Transactions</a>
            <a href="/admin/manage-accounts">Accounts</a>
            <a href="/admin/bitcoins">Bitcoins</a>
          </div>
        </div>
      </div>

      <div className="dashboard-content admin-dashboard-content">
        <div className="bitcoin-purchase-section">
          <h2>Enter Monthly Report Data</h2>
          
          <form onSubmit={handleSubmit} className="bitcoin-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="year">Year</label>
                <select
                  id="year"
                  name="year"
                  value={formData.year}
                  onChange={handleInputChange}
                  disabled={isLoading}
                  className="form-select"
                >
                  {years.map(year => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </select>
              </div>
              
              <div className="form-group">
                <label htmlFor="month">Month</label>
                <select
                  id="month"
                  name="month"
                  value={formData.month}
                  onChange={handleInputChange}
                  disabled={isLoading}
                  className="form-select"
                >
                  {months.map(month => (
                    <option key={month} value={month}>{month}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="totalDeposits">Total Deposits</label>
                <input
                  type="number"
                  id="totalDeposits"
                  name="totalDeposits"
                  value={formData.totalDeposits}
                  onChange={handleInputChange}
                  placeholder="Enter amount"
                  disabled={isLoading}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="btcPurchased">BTC Purchased</label>
                <input
                  type="number"
                  id="btcPurchased"
                  name="btcPurchased"
                  value={formData.btcPurchased}
                  onChange={handleInputChange}
                  placeholder="Enter amount"
                  step="0.00000001"
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="fees">Fees</label>
                <input
                  type="number"
                  id="fees"
                  name="fees"
                  value={formData.fees}
                  onChange={handleInputChange}
                  placeholder="Enter amount"
                  step="0.01"
                  disabled={isLoading}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="price">Price</label>
                <input
                  type="number"
                  id="price"
                  name="price"
                  value={formData.price}
                  onChange={handleInputChange}
                  placeholder="Enter amount"
                  step="0.01"
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="usdtBtcRate">USDT - BTC Rate</label>
                <input
                  type="number"
                  id="usdtBtcRate"
                  name="usdtBtcRate"
                  value={formData.usdtBtcRate}
                  onChange={handleInputChange}
                  placeholder="Enter USDT-BTC rate"
                  step="0.00000000000001"
                  disabled={isLoading}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="currentValue">Current Value</label>
                <input
                  type="number"
                  id="currentValue"
                  name="currentValue"
                  value={formData.currentValue}
                  onChange={handleInputChange}
                  placeholder="Enter current value"
                  step="0.01"
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="lossGain">Loss/Gain (%)</label>
                <input
                  type="number"
                  id="lossGain"
                  name="lossGain"
                  value={formData.lossGain}
                  onChange={handleInputChange}
                  placeholder="Enter loss/gain percentage"
                  step="0.01"
                  disabled={isLoading}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="ngnRate">NGN Rate</label>
                <input
                  type="number"
                  id="ngnRate"
                  name="ngnRate"
                  value={formData.ngnRate}
                  onChange={handleInputChange}
                  placeholder="Enter NGN rate"
                  step="0.01"
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="walletAddress">Wallet Address</label>
                <input
                  type="text"
                  id="walletAddress"
                  name="walletAddress"
                  value={formData.walletAddress}
                  onChange={handleInputChange}
                  placeholder="Address"
                  disabled={isLoading}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="availableBtc">Available BTC</label>
                <input
                  type="number"
                  id="availableBtc"
                  name="availableBtc"
                  value={formData.availableBtc}
                  onChange={handleInputChange}
                  placeholder="Enter amount"
                  step="0.00000001"
                  disabled={isLoading}
                />
              </div>
            </div>
            
            <div className="form-actions">
              <button
                type="submit"
                className="submit-button"
                disabled={isLoading}
              >
                {isLoading ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          </form>
        </div>
      </div>

      <div className="admin-footer">
        <button onClick={handleLogout} className="admin-logout-button">
          Logout
        </button>
      </div>
    </div>
  );
};

export default AdminBitcoinsScreen;

